export default class Options {
  constructor ({ is_visible = true, collapse = false, undeletable = false } = {}) {
    this.is_visible = is_visible
    this.collapse = collapse
    this.undeletable = undeletable
  }
}
